var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Árbontás")])]),_c('price-breakdown-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }